import { render, staticRenderFns } from "./HostelCard.vue?vue&type=template&id=621eff94&scoped=true&"
import script from "./HostelCard.vue?vue&type=script&lang=ts&"
export * from "./HostelCard.vue?vue&type=script&lang=ts&"
import style0 from "./HostelCard.vue?vue&type=style&index=0&id=621eff94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621eff94",
  null
  
)

export default component.exports